const LocalEcamsLogin = () => {
    return (
        <div>
            <h1>Local Ecams Login page</h1>
        </div>
    );
};

export default LocalEcamsLogin;